export default __webpack_public_path__ + "static/media/IMG_8276.9853463a.webp";